import { Product, useJurisdictionStore } from './use-jurisdiction';

export const useIsSweepsProduct = () => useJurisdictionStore(state => state.product === Product.Sweeps);
